import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Button, ButtonGroup } from 'components/misc'


export default class SettingActions extends Component {
  static propTypes = {
    settings: PropTypes.string,
    setSettings: PropTypes.func.isRequired,
    reset: PropTypes.func.isRequired,
    count: PropTypes.number
  }

  handleSetFilter = () => {
    this.props.reset()
    this.props.setSettings()
  }

  render() {
    const { count, settings } = this.props

    return (
      <ButtonGroup right paddedBottom={Boolean(count)}>
        {settings && (
          <Button
            type="button"
            intlKey="button.clear"
            secondary
            onClick={this.handleSetFilter}
          >
            Clear
          </Button>
        )}
        <Button intlKey="button.apply">
          Apply
        </Button>
      </ButtonGroup>
    )
  }
}
